// Helper for any prop that behaves like `as` from styled-components (ie `component` in Button)
// Compatibility type to include all html attributes with a fix for the `as` prop collision
// Compatibility type to include all svg attributes with a fix for the `as` prop collision
// eslint-disable-next-line
export function assertNever(_) {
  throw new Error('Unreachable value');
}
/**
 * Construct a type with the properties of T except for those in type K.
 *
 * https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-5.html#the-omit-helper-type
 * Included to support library consumers on TypeScript versions prior to 3.5
 * (Also, can't require TypeScript as dependency to continue supporting JS packages)
 */